import { render, staticRenderFns } from "./PointersOfMonthDetail.vue?vue&type=template&id=fed37266&scoped=true"
import script from "./PointersOfMonthDetail.vue?vue&type=script&lang=js"
export * from "./PointersOfMonthDetail.vue?vue&type=script&lang=js"
import style0 from "./PointersOfMonthDetail.vue?vue&type=style&index=0&id=fed37266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed37266",
  null
  
)

export default component.exports